import axios from 'axios';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import { SocialNetwork } from '@repo/types';
import API from '../endpoints';
import { getAccessToken } from '../utils/getAccessToken';

// 30 minutes frontend cache for social network list query
const CACHE_TIME = 30 * 60 * 1000;

export const useSocialNetworksQuery = () => {
  return useQuery({
    queryKey: ['socialNetworks'],
    queryFn: fetchSocialNetworks,
    staleTime: !getAccessToken() ? CACHE_TIME : undefined,
  });
};

const fetchSocialNetworks: QueryFunction<SocialNetwork[], [string]> = async () => {
  const accessToken = getAccessToken();
  const { data } = await axios.get<SocialNetwork[]>(API.endpoints.socialNetworks, {
    headers: accessToken
      ? {
          Authorization: `Bearer ${accessToken}`,
        }
      : {},
  });
  return data;
};
